import { Box, Switch, Typography, useMediaQuery, useTheme } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import {
  ESettingsTgSendMsgPermissionsFields,
  ISettingsTgSendMsgPermissionsPayload,
  IUpdateTgSendMessagePermissionsDto,
} from 'src/types'

interface IProps {
  field: ESettingsTgSendMsgPermissionsFields
  payload: ISettingsTgSendMsgPermissionsPayload
  handleUpdate: (dto: IUpdateTgSendMessagePermissionsDto) => void
  label: string
  adittionalText?: ReactNode
}

export const TgSendMessagePermissionsItem = ({
  field,
  payload,
  handleUpdate,
  label,
  adittionalText,
}: IProps) => {
  const [checked, setchecked] = useState<boolean>(payload?.[field] ?? false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_l'))

  useEffect(() => {
    if (payload) {
      setchecked(payload[field])
    }
  }, [payload])

  const handleUpdatePermission = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    setchecked(checked)
    handleUpdate({
      field,
      value: checked,
    })
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',

        alignItems: 'center',
        justifyContent: isMobile ? 'space-between' : 'start',
        gap: '8px',
        pl: isMobile ? '15px' : '50px',
      }}
    >
      <Box>
        <Typography fontSize={'14px'}>{label}</Typography>
      </Box>
      {adittionalText && adittionalText}
      <Switch
        checked={checked}
        onChange={handleUpdatePermission}
        id={field + 'tg_permissiuns'}
        name={field + 'tg_permissiuns'}
      />
    </Box>
  )
}
